/* ISAIA · scheda prodotto: la foto intera nello schermo (prova, assets/isaia-pdp-foto.css).
   Misura dove comincia la galleria a pagina in cima (testata, breadcrumb: cambiano da tema a tema) e la proporzione
   della foto attiva; poi fa ricalcolare al tema l'altezza della galleria (--height di product-images), che da solo
   la aggiorna solo quando cambia la larghezza della finestra. */
(function () {
  if (window.isaiaPdpFoto) return;
  window.isaiaPdpFoto = true;

  // posizione nel documento senza le trasformazioni delle animazioni d'ingresso
  function docTop(el) {
    var top = 0;
    for (var n = el; n; n = n.offsetParent) top += n.offsetTop;
    return top;
  }

  function fit() {
    document.querySelectorAll('product-images.isaia-pdp-fit').forEach(function (el) {
      el.style.setProperty('--isaia-pdp-top', docTop(el) + 'px');
      var photo = el.querySelector('.product__slide.media--active .product__photo') || el.querySelector('.product__photo');
      var ratio = photo && parseFloat(getComputedStyle(photo).getPropertyValue('--aspect-ratio'));
      if (ratio > 0) el.style.setProperty('--isaia-pdp-ratio', ratio);
      requestAnimationFrame(function () {
        if (typeof el.setHeight === 'function') el.setHeight();
      });
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; fit(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit);
  else fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', queue);
  document.addEventListener('shopify:section:load', fit);
})();
